const initialState = {
  base: {
    items: []
  }
}

export default initialState
